import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {Icon, IconNames} from "office-ui-fabric-react";
import React = require("react");
import {MetadataFields} from "../../../models";

export interface TeamsDocumentStatusTabReorderMetadataState extends ITeamsBaseComponentState {}

export interface TeamsDocumentStatusTabReorderMetadataProps {
    metadata: MetadataFields;
    metadataListIndex: number;
    metadataListLastIndex: number;
    shouldReorderMetadata: boolean;
    reorderCallback: (metadataField: MetadataFields, isDirectionUp: boolean) => void;
}

export class TeamsDocumentStatusTabReorderMetadata extends TeamsBaseComponent<
    TeamsDocumentStatusTabReorderMetadataProps,
    TeamsDocumentStatusTabReorderMetadataState
> {
    constructor(props: TeamsDocumentStatusTabReorderMetadataProps) {
        super(props);
    }

    public render() {
        return (
            <div hidden={!this.props.shouldReorderMetadata} className="metadataPositionIcons">
                {this.props.metadataListIndex != 2 && (
                    <Icon
                        onClick={() => {
                            this.props.reorderCallback(this.props.metadata, true);
                        }}
                        iconName={IconNames.ChevronUpMed}
                        style={{fontSize: "15px", cursor: "pointer"}}
                    />
                )}

                {this.props.metadataListIndex != this.props.metadataListLastIndex && (
                    <Icon
                        onClick={() => {
                            this.props.reorderCallback(this.props.metadata, false);
                        }}
                        iconName={IconNames.ChevronDownMed}
                        style={{fontSize: "15px", cursor: "pointer"}}
                    />
                )}
            </div>
        );
    }
}
